export default __webpack_public_path__ + "static/media/web-4.6262a346.webp";